import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';

/**
 * react-i18next setup. Default `es` (LATAM-focused per CLAUDE.md §i18n).
 * Soporta `en` si el browser lo prefiere explícitamente.
 *
 * Selección:
 * - Browser dice `es-XX` o nada → `es` (default).
 * - Browser dice `en-XX` → `en`.
 *
 * fallbackLng = `es` por mismo razonamiento. Si falta una key, mostrar el texto en
 * español es preferible que en inglés para nuestra audiencia.
 *
 * SW-128 opt H follow-up (2026-05-25): cambio del default `en` → `es` per
 * CLAUDE.md Communication Standards. La decisión previa de 2026-05-11 era
 * tentativa mientras se confirmaba la audiencia.
 */
const browserLang = typeof navigator !== 'undefined' ? navigator.language : 'es';
const initialLng = browserLang.toLowerCase().startsWith('en') ? 'en' : 'es';

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      es: { common: esCommon },
    },
    lng: initialLng,
    fallbackLng: 'es',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
  });

export { i18n };
